import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pressable, View } from 'react-native';
import { BLACK_700, BLACK_900, Card, LILAC_200, Typography, WHITE, Avatar, useBreakpoint, isValidObject, InView, getTestId } from '@airtel/air-design-system';
import { getEngagementCardStyles } from './EngagementCardStyles';
var EngagementCard = props => {
  var testID = props.testID,
    _props$darkMode = props.darkMode,
    darkMode = _props$darkMode === void 0 ? false : _props$darkMode,
    title = props.title,
    imageUrl = props.imageUrl,
    iconName = props.iconName,
    onUserAction = props.onUserAction,
    _props$type = props.type,
    type = _props$type === void 0 ? 'icon' : _props$type,
    onCardPressMetaData = props.onCardPressMetaData,
    onCardVisibleMetaData = props.onCardVisibleMetaData,
    id = props.id,
    withCardProps = props.withCardProps,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size;
  var engagementCardStyles = getEngagementCardStyles();
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var isValidImgUrl = isValidObject(imageUrl);
  return _jsx(Pressable, Object.assign({
    accessible: true,
    accessibilityRole: "button",
    accessibilityHint: "double tap to take action",
    onPress: () => {
      isValidObject(onCardPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onCardPressMetaData), {
        item: props,
        index: id
      }));
    },
    style: engagementCardStyles.pressable
  }, getTestId(testID, "card"), {
    children: _jsx(InView, Object.assign({
      triggerOnce: true,
      onChange: inView => {
        inView && onCardVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onCardVisibleMetaData), Object.assign({
          index: id
        }, props)));
      },
      style: engagementCardStyles.inview
    }, {
      children: _jsx(Card, Object.assign({
        backgroundColor: darkMode ? BLACK_900 : LILAC_200,
        borderColor: darkMode ? BLACK_700 : WHITE,
        noPadding: true
      }, withCardProps, {
        style: [engagementCardStyles.card, withCardProps === null || withCardProps === void 0 ? void 0 : withCardProps.style]
      }, {
        children: _jsxs(View, Object.assign({
          style: engagementCardStyles.subcontainer
        }, {
          children: [_jsx(Avatar, Object.assign({
            size: size
          }, type === 'image' ? {
            variant: 'image',
            imageUrl: isValidImgUrl ? isLargeScreen ? imageUrl.desktop : imageUrl.mobile : '',
            style: engagementCardStyles.avatarImgStyle
          } : {}, type === 'icon' ? {
            variant: 'icon',
            iconName: iconName
          } : {}, getTestId(testID, "avatar"))), _jsx(Typography, Object.assign({
            text: title,
            type: "body-para-xs",
            color: darkMode ? WHITE : BLACK_900,
            numberOfLines: 2,
            style: engagementCardStyles.text
          }, getTestId(testID, "text")))]
        }))
      }))
    }))
  }));
};
export default EngagementCard;